/*
 * SEAL MEDIA 2026-08-08 — holder fraktlinja på produktsiden i takt med kurven.
 * Egen liten fil framfor å utvide seal-free-shipping.js, fordi de to elementene
 * lever i hver sin seksjon og produktsiden ikke alltid har annonseringslinja.
 */
(function () {
  var el = document.getElementById('seal-fs-product');
  if (!el) return;

  var textEl = el.querySelector('.seal-fs-product__text');
  var goal = parseInt(el.dataset.goal, 10);

  function apply(totalCents) {
    var msg;
    var done = false;

    if (totalCents <= 0) {
      msg = el.dataset.msgEmpty;
    } else if (totalCents < goal) {
      msg = el.dataset.msgLeftA + Math.ceil((goal - totalCents) / 100) + el.dataset.msgLeftB;
    } else {
      msg = el.dataset.msgDone;
      done = true;
    }

    if (textEl.textContent !== msg) textEl.textContent = msg;
    el.classList.toggle('seal-fs-product--done', done);
  }

  function refresh() {
    fetch(((window.theme && theme.routes && theme.routes.cart) || '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) apply(cart.total_price); })
      .catch(function () { /* behold server-rendret tekst */ });
  }

  document.addEventListener('on:cart:change', refresh);
  document.addEventListener('on:cart:add', refresh);
})();
